import { useState } from "react";
import { showroomSpaces } from "@/mocks/showroomData";

export default function ShowroomSpaces() {
  const [active, setActive] = useState(0);
  const space = showroomSpaces[active];

  return (
    <section id="spaces" className="w-full bg-[#0d0d0d] py-20 md:py-28 lg:py-32">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-18">
          <div>
            <p
              className="text-[11px] uppercase tracking-[0.28em] text-[#B8422E] mb-4"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              / The Spaces
            </p>
            <h2
              className="text-3xl md:text-4xl lg:text-[52px] font-extrabold text-white leading-[1.06] tracking-[-0.02em]"
              style={{ fontFamily: "'Public Sans', sans-serif" }}
            >
              Two Floors.
              <br />
              <span className="text-[#6C7278] font-light">Every Room.</span>
            </h2>
          </div>
          <p
            className="text-sm text-[#6C7278] max-w-xs leading-relaxed"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            Our showroom is organized by room — so you can experience each space as a complete, curated environment.
          </p>
        </div>

        {/* Tab selector */}
        <div className="flex flex-wrap gap-px bg-white/[0.06] mb-px">
          {showroomSpaces.map((s, i) => (
            <button
              key={s.id}
              onClick={() => setActive(i)}
              className={`flex-1 min-w-[140px] px-5 py-4 text-left transition-all duration-300 cursor-pointer whitespace-nowrap ${
                active === i
                  ? "bg-white text-[#1A1C1E]"
                  : "bg-[#0d0d0d] text-[#6C7278] hover:text-white hover:bg-white/[0.04]"
              }`}
            >
              <p
                className="text-[10px] uppercase tracking-[0.18em] mb-1 opacity-60"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {s.tag}
              </p>
              <p
                className="text-[13px] font-semibold"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {s.name}
              </p>
            </button>
          ))}
        </div>

        {/* Active space display */}
        <div className="flex flex-col lg:flex-row gap-px bg-white/[0.06]">
          {/* Image */}
          <div className="flex-1 min-h-[320px] md:min-h-[480px] lg:min-h-[560px] overflow-hidden">
            <img
              key={space.id}
              src={space.image}
              alt={space.name}
              className="w-full h-full object-cover object-center transition-opacity duration-500"
              style={{ minHeight: "320px" }}
            />
          </div>

          {/* Info panel */}
          <div className="w-full lg:w-[360px] flex-shrink-0 bg-[#111213] p-8 md:p-10 flex flex-col justify-between">
            <div>
              <p
                className="text-[10px] uppercase tracking-[0.22em] text-[#B8422E] mb-4"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {space.tag}
              </p>
              <h3
                className="text-2xl md:text-3xl font-extrabold text-white leading-tight tracking-[-0.02em]"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                {space.name}
              </h3>
              <p
                className="mt-5 text-sm text-[#6C7278] leading-relaxed"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                {space.description}
              </p>
            </div>

            <div className="mt-10">
              <div className="h-px bg-white/[0.06] mb-8" />
              <div className="flex items-center justify-between mb-6">
                <p
                  className="text-[11px] uppercase tracking-[0.18em] text-[#6C7278]"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {active + 1} / {showroomSpaces.length}
                </p>
                <div className="flex gap-2">
                  <button
                    onClick={() => setActive((prev) => Math.max(0, prev - 1))}
                    disabled={active === 0}
                    className="w-9 h-9 flex items-center justify-center border border-white/15 text-[#6C7278] hover:border-white/40 hover:text-white disabled:opacity-30 transition-all cursor-pointer"
                    style={{ borderRadius: "4px" }}
                  >
                    <i className="ri-arrow-left-line text-sm" />
                  </button>
                  <button
                    onClick={() => setActive((prev) => Math.min(showroomSpaces.length - 1, prev + 1))}
                    disabled={active === showroomSpaces.length - 1}
                    className="w-9 h-9 flex items-center justify-center border border-white/15 text-[#6C7278] hover:border-white/40 hover:text-white disabled:opacity-30 transition-all cursor-pointer"
                    style={{ borderRadius: "4px" }}
                  >
                    <i className="ri-arrow-right-line text-sm" />
                  </button>
                </div>
              </div>
              <a
                href="#visit"
                className="inline-flex items-center justify-center gap-2 w-full py-3.5 bg-[#B8422E] text-white text-[12px] font-semibold hover:bg-[#9E3826] transition-colors duration-300 whitespace-nowrap"
                style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
              >
                Book a Visit
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
